/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

const config = {
    table: {
        header: [
            {
                prop: 'orderNo',
                label: '子单号',
                type: 'link'
            },
            {
                prop: 'qty',
                label: '预占数量',
                width: 160
            },
            {
                prop: 'createTime',
                label: '预占时间',
                width: 160
            },
            {
                prop: 'orderNo',
                label: '操作',
                width: 160,
                type: 'action'
            }
        ]
    }
};

export default config;
